import { deepPurple } from "@mui/material/colors";

// Rebrand color constants for the legacy MUI theme.
// These mirror the Berlin rebrand palette (src/appV2/redesign/theme/rebrand/colors.ts).

// --- Core brand colors ---
export const REBRAND_PRIMARY_COLOR = "#DA2451";
export const REBRAND_PRIMARY_DARK = "#862335";
export const REBRAND_SECONDARY_COLOR = "#37171A";
export const REBRAND_MUTED_COLOR = "#7B645C";
export const REBRAND_DANGER_COLOR = "#DD3630";
export const REBRAND_LINK_COLOR = "#37171A";
export const REBRAND_TEXT_STRONG = "#210E10";
export const REBRAND_WARNING_COLOR = "#CE7210";

// --- Gray equivalents ---
export const REBRAND_GRAY_00 = "#210E10";
export const REBRAND_GRAY_4F = "#7B645C";
export const REBRAND_GRAY_C0 = "#9F8D7F";
export const REBRAND_GRAY_E0 = "#ECE7DC";
export const REBRAND_GRAY_F0 = "#F8F4EA";
export const REBRAND_GRAY_1F = "#37171A";

// --- Shift AM/PM/NOC dark variants (for text on light backgrounds) ---
export const REBRAND_AM_DARK = "#F69551";
export const REBRAND_PM_DARK = "#4DBEF5";
export const REBRAND_NOC_DARK = "#A072F7";

// --- Background colors ---
export const REBRAND_BACKGROUND_BASE = "#FFFEFC";
export const REBRAND_BACKGROUND_PAGE = "#FDF9F3";

// --- DataGrid / dark header ---
export const REBRAND_HEADER_DARK = "#210E10";

// --- Alert colors ---
export const REBRAND_ALERT_COLORS = {
  warning: {
    backgroundColor: "#FBFCE5",
    color: "#CE7210",
  },
  info: {
    backgroundColor: "#FDE9EA",
    color: "#DA2451",
  },
  error: {
    backgroundColor: "#FFD9D2",
    color: "#DD3630",
  },
  success: {
    backgroundColor: "#D2F2D2",
  },
};

// --- Chip colors ---
export const REBRAND_CHIP_COLORS = {
  primary: { color: REBRAND_PRIMARY_COLOR, backgroundColor: "#FDE9EA" },
  secondary: { color: REBRAND_SECONDARY_COLOR, backgroundColor: REBRAND_GRAY_E0 },
  success: { color: "#24C23F", backgroundColor: "#D2F2D2" },
  error: { color: REBRAND_DANGER_COLOR, backgroundColor: "#FFD9D2" },
  warning: { color: REBRAND_WARNING_COLOR, backgroundColor: "#FBFCE5" },
  info: { color: REBRAND_PRIMARY_COLOR, backgroundColor: "#FDE9EA" },
  accent: { backgroundColor: deepPurple[100], color: deepPurple[800] },
  blue600: { color: "#E8F4FF", backgroundColor: "#082A74" },
  green600: { color: "#E0FBEF", backgroundColor: "#169563" },
};

// --- Typography ---
export const REBRAND_TYPOGRAPHY_COLORS = {
  body2: {
    light: REBRAND_GRAY_4F,
    dark: REBRAND_GRAY_00,
  },
};
